export default __webpack_public_path__ + "static/media/PrepRecovery_Mobile@2x.d160717e.png";